import { Divider, Typography } from "@mui/material";

import styles from "./FeatureFlagsPage.module.css";
import { FeatureFlagsPanel } from "./FeatureFlagsPanel";
import { UserGroupsPanel } from "./UserGroupsPanel";

export function FeatureFlagsPage() {
  return (
    <>
      <Typography variant="h6" className={styles.sectionHeading}>
        Feature Flags
      </Typography>
      <FeatureFlagsPanel />
      <Divider className={styles.divider} />
      <Typography variant="h6" className={styles.sectionHeading}>
        User Groups
      </Typography>
      <UserGroupsPanel />
    </>
  );
}
